<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/applications">{{ $t('leave_app') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('new') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link v-if="model.Status=='Draft'" :to="{ name: 'leave_application_update', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor">
                <i class="fa fa-pencil"></i> {{$t('edit')}}
            </router-link>
            <button v-if="model.Status=='Draft'" type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onApprove"><i class="fa fa-check"></i> {{ $t('approval') }}</button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-6">
                            <h2 class="text-center">Leave Request Form</h2>
                            <p>Date: {{$format(model.SubmittedDate, 'DD/MM/YYYY')}}</p>
                            <table class="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td>Employee name: {{employee.KhmerName}}</td>
                                        <td>Scheme: {{model.LeaveSchemeName}}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <p>Reason for request leave: (Please tick appropriate box)</p>
                                            <div>
                                                <p v-for="ret in leaveTypes" :key="ret.Id"> <input type="checkbox" :checked="ret.Id == model.LeaveTypeId" disabled/> {{ret.Code + ' : ' + ret.Description}}</p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <p>Apply type: {{model.ApplyType}}</p>
                                            Date requested: from {{$format(model.FromDate,'DD/MM/YYYY')}} to {{$format(model.ToDate,'DD/MM/YYYY')}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">Reason: {{model.Reason}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data() {
            return {
                model: {},
                employee: {},
                leaveTypes: []
            }
        },
        created(){
            var id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
                this.findById(id);
            }
        },
        methods: {
            findById(id){
                var loading = this.$loading.show();
                this.$api().post('leave/application/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.model = res.data.Json.Application;
                        this.model.LeaveSchemeId = res.data.Json.Scheme.Id;
                        this.model.LeaveSchemeName = res.data.Json.Scheme.Code;
                        this.leaveTypes = res.data.Json.LeaveTypes;
                        this.employee = res.data.Json.Employee;
                    }
                }).finally(function() { loading.hide(); });
            },
            onApprove(){
                var loading = this.$loading.show();
                this.$api().post('leave/application/approval', { Id: this.$route.params.id }).then(res => {
                    if(this.$isValid(res)){
                        this.$router.go(-1);
                    }
                }).finally(function() { loading.hide(); });
            }
        }
    }
</script>
